var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 0 7.5 L 0 12.5 L 50 12.5 L 50 7.5 Z M 0 22.5 L 0 27.5 L 50 27.5 L 50 22.5 Z M 0 37.5 L 0 42.5 L 50 42.5 L 50 37.5 Z"}));
}

Menu.defaultProps = {"x":"0px","y":"0px","width":"50","height":"50","viewBox":"0 0 50 50","style":{"fill":"#000000"}};

module.exports = Menu;

Menu.default = Menu;
